<template>
    <Transition v-if="isLoading" name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="formProps.formName" @keyup.enter="autoSave = true">
        <Tabs value="0" scrollable>

            <TabList>
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormStaticText label="Operation date" size="4" labelClass="static-text-label" class="static-text-content" :content="crud.created_at" />

                        <FormStaticText label="User" size="4" labelClass="static-text-label" class="static-text-content" :content="crud.user" />

                        <FormStaticText label="From" size="4" labelClass="static-text-label" class="static-text-content" :content="crud.from" />
                    </div>
                    <div class="grid">
                        <FormStaticText label="To" size="4" labelClass="static-text-label" class="static-text-content" :content="crud.to" />

                        <FormStaticText label="Cc" size="4" labelClass="static-text-label" class="static-text-content" :content="crud.cc" />

                        <FormStaticText label="Bcc" size="4" labelClass="static-text-label" class="static-text-content" :content="crud.bcc" />
                    </div>
                    <div class="grid">
                        <FormStaticText label="Subject" labelClass="static-text-label" class="static-text-content" :content="crud.subject" />
                    </div>
                    <div class="grid">
                        <FormStaticText label="Body" labelClass="static-text-label" class="static-text-content" :content="crud.body" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps" :sourceForm="crud" :validation="validation" :buttonsVisibility="buttonsVisibility" v-model:isFormDisabled="isFormDisabled" v-model:autoSave="autoSave">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormStaticText from '@crud/FormStaticText.vue'
import FormButtons from '@crud/FormButtons.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(false)
const autoSave = ref(false)

const crud = ref({})
const buttonsVisibility = ref({})

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, null, null, buttonsVisibility)
})

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
